import type { DialogProps } from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import type { ReactElement, ReactNode } from 'react';

import { styleConfigs } from '../../../resources/styleConfigs';
import DialogWrapper from '../../../wrappers/DialogWrapper';

export type DialogStyledProps = Omit<DialogProps, 'children'> & {
  children: ReactNode;
  desktopWidth?: string | number;
  desktopHeight?: string | number;
};

const DialogStyledEngine = styled(DialogWrapper, {
  shouldForwardProp: (prop) => prop !== 'desktopWidth' && prop !== 'desktopHeight',
})<DialogStyledProps>(({ theme, desktopWidth, desktopHeight }) => {
  const paperStyles = typeof desktopWidth === 'string' ? { maxWidth: styleConfigs.dimensions.none } : {};

  return {
    transition: theme.transitions.create('width', {
      duration: theme.transitions.duration.complex,
    }),
    '& .MuiDialog-container': {
      paddingInline: styleConfigs.marginPadding.custom32,
    },
    '& .MuiDialog-paper': {
      width: desktopWidth,
      maxHeight: desktopHeight,
      height: desktopHeight,
      margin: styleConfigs.marginPadding.empty,
      ...paperStyles,
    },
  };
});

export function DesktopModalDialog(props: DialogStyledProps): ReactElement {
  return <DialogStyledEngine {...props} />;
}
